export default __webpack_public_path__ + "media/artificial-intelligence-collection.157ae78523fff0d5a028c699ebb44bc2.svg";